import React from 'react';
import { BaseLayout } from './base';

export let MarketingLayout = ({ children }: { children: React.ReactNode }) => {
  return <BaseLayout>{children}</BaseLayout>;
};
